import { render, staticRenderFns } from "./IncomeClarify.vue?vue&type=template&id=3ec2841e&scoped=true&"
import script from "./IncomeClarify.vue?vue&type=script&lang=ts&"
export * from "./IncomeClarify.vue?vue&type=script&lang=ts&"
import style0 from "./IncomeClarify.vue?vue&type=style&index=0&id=3ec2841e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec2841e",
  null
  
)

export default component.exports